import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/EndPoint";
import Button from "../Reusable/Button";
import { useState } from "react";
import { toast } from "react-toastify";
import ComboboxInput from "../Reusable/ComboboxInput";
const ChangeOrderStatus = ({ handleRemove, isLoading }: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>({});

  const {
    data,
    isLoading: isGettingStatusInfo,
    isRefetching,
  } = useGetHook({
    queryKey: [watch("status")],
    url: watch("status") ? `${APIS.STATUS}${watch("status")}/` : APIS.STATUS,
    params: {},
  });
  console.log(data?.id, "selected status");
  const [searchParams, setSearchParms] = useSearchParams();

  const orderIds = searchParams.get("selectedItems")?.split(",") || [];

  const [orderActionMenu, setOrderActionMenu] = useState(false);

  const handleActionMenu = () => {
    if (!orderIds) {
      toast.error("Please select at least one order first");
      setOrderActionMenu(false);
      return;
    }
    handleRemove(orderIds, data?.id);
  };

  return (
    <div className={tw`w-full`}>
      <form
        onSubmit={handleSubmit(() => handleActionMenu())}
        autoComplete="off"
      >
        <div className={tw`flex flex-col justify-between min-h-full`}>
          <ComboboxInput
            url={APIS.STATUS}
            queryKey={"status"}
            register={register("status" as const, {
              required: "Status is required",
            })}
            errors={errors?.status}
            name={"status"}
            watch={watch}
            label={""}
            setValue={setValue}
            placeholder={"Search Status"}
            getValues={getValues}
            props={{ order_ids: orderIds }}
            clearErrors={clearErrors}
          />
          {/* 
          {!Array.isArray(data) && data?.is_partial_status ? (
            <>
              <div className={tw`py-4`}>
                <TextField
                  label={"Collected COD"}
                  register={register("collected_cod" as const, {
                    required: "Collected COD is required",
                  })}
                  errors={errors?.collected_cod}
                />
                <TextField
                  label={"Remark"}
                  register={register("remark" as const, {
                    required: "Remark is required",
                  })}
                  errors={errors?.remark}
                />
              </div>
            </>
          ) : null} */}
          <div className={tw`w-[180px] ml-auto`}>
            <Button
              label={"Submit and Remove"}
              isLoading={isLoading}
              disabled={isRefetching}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ChangeOrderStatus;
